import './Form.css'

export default function ContactForm() {
  return (
    <div key="contact" className="contact-container">
      <form
        action={process.env.REACT_APP_FORM_CARRY}
        method="POST"
        className="contact-form"
      >
        <p className="form-heading">
          Fill this form to get in touch with us
        </p>

        <label className="form-label">
          E-mail
          <input
            type="email"
            name="email"
            required
            autoComplete="email"
            inputMode="email"
            maxLength={254}
            placeholder="name@example.com"
            pattern="^[^\s@]+@[^\s@]+\.[^\s@]+$"
            title="Please enter a valid email address."
            className="form-input"
          />
        </label>

        <label className="form-label">
          Message
          <textarea
            name="message"
            required
            rows={4}
            minLength={10}
            maxLength={2000}
            placeholder="How can we help?"
            className="form-textarea"
          />
        </label>

        <button
          type="submit"
          className="form-button"
        >
          Send
        </button>
      </form>
      <div className='notice'>By sending this form you accept our <a href="/Privacy">Privacy Policy</a></div>
      <p>You can view our Customer Terms and Conditions <a href="/Terms-and-Conditions">here.</a></p>
    </div>
  )
}
